<template>
  <Layout>
    <div class="container">
      <!-- <div class="text-right mb-3">
        <router-link to="/article/:id" class="btn btn-info">
          <i class="fa fa-plus"></i> Add Article
        </router-link>
      </div> -->
      <div class="row">
        <div class="card">
          <div class="row align-items-center my-5">
            <div class="col-lg-7">
              <img
                class="img-fluid rounded mb-4 mb-lg-0 p-3"
                src="https://images.unsplash.com/photo-1558981403-c5f9899a28bc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80"
                alt
              />
            </div>
            <!-- /.col-lg-8 -->
            <div class="col-lg-5 pl-2 pr-2">
              <h1 class="font-weight-light pl-3 pr-2">Business Name or Tagline</h1>
              <p
                class="pl-3 pr-2 mr-2"
              >This is a template that is great for small businesses. It doesn't have too much fancy flare to it, but it makes a great use of the standard Bootstrap core components. Feel free to use this template for any project you want!</p>
              <router-link to="/article/:id" class="btn btn-primary ml-3">Read More</router-link>
            </div>
            <!-- /.col-md-4 -->
          </div>
        </div>

        <div class="card">
          <div class="row align-items-center my-5">
            <div class="col-lg-7">
              <img
                class="img-fluid rounded mb-4 mb-lg-0 p-3"
                src="https://images.unsplash.com/photo-1559526324-593bc073d938?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80"
                alt
              />
            </div>
            <!-- /.col-lg-8 -->
            <div class="col-lg-5 pl-2 pr-2">
              <h1 class="font-weight-light pl-3 pr-2">Business Name or Tagline</h1>
              <p
                class="pl-3 pr-2 mr-2"
              >This is a template that is great for small businesses. It doesn't have too much fancy flare to it, but it makes a great use of the standard Bootstrap core components. Feel free to use this template for any project you want!</p>
              <router-link to="/article/:id" class="btn btn-primary ml-3">Read More</router-link>
            </div>
            <!-- /.col-md-4 -->
          </div>
        </div>
      </div>
      <!-- /.row -->
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
export default {
  name: "article",
  components: {
    Layout
  }
};
</script>

<style scoped>
/* .card-img-top {
    width: 100%;
    height: 450px;
} */
</style>